import { Directive, ElementRef, HostListener } from '@angular/core';
 
 @Directive({
   selector: '[appWholeNumberOnly]',
   standalone: true
 })
 export class WholeNumberOnlyDirective {
 
   constructor(private el: ElementRef) { }
 
   @HostListener('keypress', ['$event'])
   onKeyPress(event: KeyboardEvent) {
     const input = this.el.nativeElement as HTMLInputElement;
     const currentValue = input.value;
     const charCode = event.key;
 
     // Allow only digits (0-9)
     if (!/^[0-9]$/.test(charCode)) {
       event.preventDefault();
       return;
     }
 
     // Limit to 9 digits
     if (currentValue.length >= 9) {
       event.preventDefault();
     }
   }
 
   @HostListener('paste', ['$event'])
   onPaste(event: ClipboardEvent) {
     const input = this.el.nativeElement as HTMLInputElement;
     const pastedInput = event.clipboardData?.getData('text') || '';
     const currentValue = input.value;
 
     // Only allow digits and ensure total length doesn't exceed 9
     if (!/^\d+$/.test(pastedInput) || (currentValue.length + pastedInput.length > 9)) {
       event.preventDefault();
     }
   }
 }